import type { OutcomeCard } from '@/pages/home/aboutLc.content'

interface OutcomeCardsSectionProps {
  titleHigh: string
  titlePrimary: string
  titleHighMobileA: string
  titleHighMobileB: string
  titlePrimaryMobileA: string
  titlePrimaryMobileB: string
  cards: OutcomeCard[]
}

function CardItem({ card }: { card: OutcomeCard }) {
  return (
    <article className="flex flex-col bg-[#dceaff] rounded-[24px] lg:rounded-[32px] overflow-hidden pb-8 lg:pb-10 w-full">
      <picture className="block w-full">
        <source media="(min-width: 1024px)" srcSet={card.imageUrl} />
        <img
          src={card.imageUrlMobile}
          alt=""
          aria-hidden
          className="w-full h-[180px] lg:h-[248px] object-cover object-bottom"
        />
      </picture>
      <div className="flex flex-col gap-4 items-center text-center px-4 mt-6 lg:mt-8 tracking-[-0.6px]">
        <h3 className="font-bold text-[24px] lg:text-[28px] leading-[1.4] whitespace-nowrap">
          <span className="text-qb-primary">{card.titlePrimary}</span>
          <span className="text-qb-text-high">{card.titleHigh}</span>
        </h3>
        <p className="font-normal text-qb-text-mid text-[18px] leading-[1.5] whitespace-pre-line">
          {card.description}
        </p>
      </div>
    </article>
  )
}

export function OutcomeCardsSection({
  titleHigh,
  titlePrimary,
  titleHighMobileA,
  titleHighMobileB,
  titlePrimaryMobileA,
  titlePrimaryMobileB,
  cards,
}: OutcomeCardsSectionProps) {
  return (
    <section id="outcomes" data-marketing-section="" className="w-full bg-qb-bg py-14 lg:py-24 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 flex flex-col items-center gap-14 lg:gap-20">
        {/* Title */}
        <h2 className="text-center font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
          <span className="block text-qb-text-high">
            <span className="hidden lg:inline">{titleHigh}</span>
            <span className="lg:hidden">
              {titleHighMobileA}
              <br aria-hidden />
              {titleHighMobileB}
            </span>
          </span>
          <span className="block mt-1 lg:mt-2.5 text-qb-primary">
            <span className="hidden lg:inline">{titlePrimary}</span>
            <span className="lg:hidden">
              {titlePrimaryMobileA}
              <br aria-hidden />
              {titlePrimaryMobileB}
            </span>
          </span>
        </h2>

        {/* Cards — desktop 3 columns, mobile stacked */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 w-full max-w-[360px] lg:max-w-none mx-auto">
          {cards.map((card) => (
            <CardItem key={card.titlePrimary + card.titleHigh} card={card} />
          ))}
        </div>
      </div>
    </section>
  )
}
